export { SEARCH_QUERY_MAX_LENGTH } from '@/lib/search-query';
export const RECENT_SEARCH_LIMIT = 5;
export const RECENT_SEARCH_KEY = 'recent-search-key';
export const RECENT_SEARCH_MIN_LENGTH = 3;
/** Typing suggestions: left column shows up to this many product + phrase rows (products first). */
export const TYPING_LEFT_COLUMN_LIMIT = 5;
/** Desktop: 0 so the suggestions panel meets the input border (one card with Figma). */
export const POPOVER_DESKTOP_SIDE_OFFSET = 0;
